<template>
  <div class="header">
    <before-page-header v-if="isBeforeConnect" />
    <connect-header v-else />

    <span>
      <span
        class="device-info"
        v-if="isConversation && isProxy"
        @click="showDeviceInfo"
        >设备信息</span
      >
      <span
        class="close"
        @click="closeWindow"
        v-if="isConversation && !isBeforeConnect"
        ><i class="el-icon-switch-button"></i>&nbsp;&nbsp;结束会话</span
      >
      <span
        class="close"
        @click="closePage"
        v-if="!isConversation && !isBeforeConnect && isQueue"
        >&nbsp;&nbsp;退出排队</span
      >
    </span>
    <device-info
      :isShowDeviceInfo="isShowDeviceInfo"
      @closeDeviceDialog="isShowDeviceInfo = false"
    />
  </div>
</template>

<script>
//各页面头部
import beforePageHeader from "./before-page-header";
import connectHeader from "./connect-header";
import deviceInfo from "./dialogs/device-info";
import utils from "../../utils";
import constants from "src/app/customer/constant";

// console.log(deviceInfo, "dec");

export default {
  name: "page-header",
  components: { beforePageHeader, connectHeader, deviceInfo },
  computed: {
    ...mapState([
      "userId",
      "isBeforeConnect",
      "isConversation",
      "isQueue",
      "enterScene"
    ]),

    isProxy() {
      console.log("this.enterScene：", this.enterScene, typeof this.enterScene);
      const enterId = parseInt(this.enterScene, 10);
      const isDymaticProxyId = enterId > 7;
      return enterId === constants.WakeUpScene.proxy || isDymaticProxyId;
    }
  },
  data() {
    return {
      isShowDeviceInfo: false
    };
  },
  methods: {
    ...mapActions({
      closeWindow: "closeWindow"
    }),
    showDeviceInfo() {
      this.isShowDeviceInfo = true;
    },
    closePage() {
      utils.closePage();
    }
  }
};
</script>

<style scoped lang="less">
.device-info {
  color: var(--connect-header-color);
  font-size: 12px;
  cursor: pointer;
  margin-right: 22px;
}

.close {
  color: var(--connect-header-color);
  font-size: 12px;
  cursor: pointer;
}
.header {
  display: flex;
  background-color: var(--header-bg);
  color: var(--header-title);
  height: 68px;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;

  .el-icon-close {
    font-size: 26px;
    color: #1e1e1e;
    cursor: pointer;
  }
}
.dialog-footer {
  height: 30px;
  .button {
    width: 65px;
    float: right;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 5px;
    margin-right: 10px;
    font-size: 12px;
  }
  .cannel {
    color: #606266;
    border: 1px solid #ccc;
    &:hover {
      border: 1px solid var(--header-bg);
      color: var(--header-bg);
    }
  }
  .sure {
    color: #fff;
    background: var(--header-bg);
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
